import styled from 'styled-components'
import { TextSm } from '../../styles/text'
import { cores } from '../../styles'

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;

  a {
    &:hover {
      color: ${cores.corSecundaria};
    }
  }
`

export const FooterText = styled(TextSm)`
  color: #ffffff;
`
